import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { AdminService } from '../admin.service';
import { NgxLoadingModule } from 'ngx-loading';
import { MatExpansionModule } from '@angular/material/expansion';
import { LocalTime } from '../../local-time.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-legacy-profile-history',
  templateUrl: './legacy-profile-history.component.html',
  styleUrls: ['./legacy-profile-history.component.scss'],
  imports: [
    NgxLoadingModule,
    MatExpansionModule,
    LocalTime,
    MatIconModule,
    MatSidenavModule,
    MatTabsModule,
    CurrencyPipe,
  ],
})
export class LegacyProfileHistoryComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private route = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);

  profile;
  changeSummary;
  loading = false;
  solution;
  rights = [];

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.profile = params['params']['profileId'];
      this.solution = params['params']['solution']?.toLowerCase();
    });
    this.getProfileHistory();
    this.rights = this.ss.get('rights') ? this.ss.get('rights') : [];
  }

  getProfileHistory() {
    this.loading = true;
    this.admnSrvc
      .getProfileHistory(this.profile, this.solution)
      .subscribe(x => {
        this.changeSummary = x.results;
        this.loading = false;
      });
  }
}
